"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ProtectedRoute_1 = __importDefault(require("./ProtectedRoute"));
exports.default = ProtectedRoute_1.default;
